/* eslint-disable import/extensions */
import {
  appraisalDashboardModule,
  webCommonService,
  webBorrowerPortalService,
  budgetReviewModule,
  budgetReconcileModule,
  drawModule,
  webLoanService,
  webDashboardService,
  webConditionDashboardService
} from "./mfe-remotes-config/remoteConfig.js";

window[webDashboardService.urlGlobalVariable] = webDashboardService.url;
window[webCommonService.urlGlobalVariable] = webCommonService.url;
window[webLoanService.urlGlobalVariable] = webLoanService.url;
window[appraisalDashboardModule.urlGlobalVariable] =
  appraisalDashboardModule.url;
window[webBorrowerPortalService.urlGlobalVariable] =
  webBorrowerPortalService.url;
window[budgetReviewModule.urlGlobalVariable] = budgetReviewModule.url;
window[budgetReconcileModule.urlGlobalVariable] = budgetReconcileModule.url;
window[drawModule.urlGlobalVariable] = drawModule.url;
window[webConditionDashboardService.urlGlobalVariable] =
  webConditionDashboardService.url;

import("./bootstrap.jsx");
